export default __webpack_public_path__ + "static/media/ico-order-inactive.9ac0312d.svg";